import React, { FC }           from 'react';
import { Icon, SemanticICONS } from 'semantic-ui-react';

export interface MenuItemArrowIndicatorProps {
	active?: boolean,
	position?: 'up' | 'down' | 'left' | 'right'
}

const defaultProps: MenuItemArrowIndicatorProps = {
	position: 'right',
	active:   false,
}

const MenuItemArrowIndicator: FC<MenuItemArrowIndicatorProps> = ( props ) => {
	
	let { active, position } = props;
	
	return (
		<Icon name={ `chevron ${ position }` as SemanticICONS }
		      color={ active ? 'teal' : 'grey' }
		      className={ `opacity--${ active ? 100 : 15 }` }/>
	);
};

MenuItemArrowIndicator.defaultProps = defaultProps;

export { MenuItemArrowIndicator }
